import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=249dcf40"
import script from "./Component.vue?vue&type=script&setup=true&lang=ts"
export * from "./Component.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports